<template>
  <div>
    <div class="main-header">
      <div class="container">
        <h2 class="main-header-text">Manage Debit Card</h2>
      </div>
    </div>
    <div class="main-section mgt-40">
      <div class="container">
        <div class="main-card">
          <img src="/static/img/icons/arrow-down-indicator-red.png" alt="" class="top-indicator" />

          <div class="row">
            <div class="col-lg-8">
              <div class="add-card rounded-border" @click="SaveDebitCard()" v-if="1==1">
                <div class="col-md-8">
                  <i class="fas fa-plus rounded-border"></i>
                  &nbsp;&nbsp; Please Add Your New Debit Card
                </div>
              </div>
              <div v-for="(card, index) in IPAY88DebitCardCollection" :key="card.Id">
                <div class="debit-card" :class="{ scselect: el == card.Id }">
                  <div class="row">
                    <div class="col-md-2">
                      <img src="/static/img/debitcard.svg" alt style="height: 35px" />
                    </div>
                    <div class="col-md-9">
                      <p>{{ card.BankName }}</p>
                      {{ card.CCNo }}
                    </div>
                    <div class="col-md-1">
                      <i class="fas fa-trash-alt fa-2x" @click="deleteDebitCard(card.Id, index)"></i>
                    </div>
                  </div>
                </div>
                <br />
              </div>
              <br />
              <div class="row">
                <div class="col-md-2"></div>
                <div class="col-md-8" style="background-color: #f6f6f6;">
                  <p>
                    Note: Your card will be charged MYR 1.00 to make sure it's valid. The amount will be automatically refunded.
                  </p>
                </div>
              </div>
              <br />
              <div class="left-option">
                <router-link :to="'/dashboard'" class="btn submit-lefticon-btn">
                  <span class="left-icon">
                    <i class="fas fa-angle-left"></i>
                  </span>
                  <span class="btn-content">Cancel</span>
                </router-link>
              </div>
            </div>
            <!-- eo col-8 -->           

            <div class="col-lg-4">
              <UserDetailSection />
            </div>
          </div>
          <div class="hidden ipay88Wrapper" ref="ipay88Wrapper"></div>
          <!-- eo row -->
        </div>
        <!-- eo main card -->
      </div>
      <!-- eo container -->
    </div>
    <!-- eo main section -->
  </div>
</template>
<script>
  import UserDetailSection from "../../shared/UserDetailSection.vue";
  import ListService from "../../services/list";
  export default {
    components: { UserDetailSection },
    beforeRouteEnter(to, from, next) {
      var promises = [];
      promises.push(ListService.get("payment/debitcards"));
      Promise.all(promises).then((response) => {
        next((p) => {
          var ipay88DebitCards = response[0].body;
          p.IPAY88DebitCardCollection = ipay88DebitCards.Individual;
        });
      });
    },
    data() {
      return {
        IPAY88DebitCardCollection: null,
      };
    },
    methods: {
      SaveDebitCard() {
        this.$http.post("account/ipay88web/debitcardrequest").then(
          (res) => {
            var ipay88 = document.querySelector(".ipay88Wrapper");
            ipay88.innerHTML = res.body.Body;
            var f = ipay88.querySelector("#ePayment");
            f.submit();
          }
        );
      },
      deleteDebitCard(cardId, index) {
        var self = this;
        kendo.confirm("Are you sure to delete selected debit card!").then(
          function () {
            self.$http
              .post("account/ipay88/deletedebitcard", {
                Id: cardId,
              })
              .then((response) => {
                var res = response.body;
                if (res.Success == true) {
                  self.IPAY88DebitCardCollection.splice(index, 1);
                  kendo.alert(res.ResponseMessage);
                } else {
                  kendo.alert(
                    "Sorry, your card was not deleted due to some errors."
                  );
                }
              });
          },
          function () {
            // kendo.alert("Sorry, your card was not deleted due to some errors.");
          }
        );
      },
    },
  };
</script>

<style scoped>
  .debit-card {
    padding: 0 2%;
  }

  .debit-card .row {
    border-radius: 10px;
  }

  .debit-card .col-md-1,
  .debit-card .col-md-2,
  .debit-card .col-md-9,
  .add-card {
    cursor: pointer;
  }

  .debit-card .col-md-1 {
    padding-top: 1%;
  }

  .debit-card .col-md-1 :hover {
    color: red;
  }

  .rounded-border {
    padding: 1%;
    border: 1px solid lightgray;
    border-radius: 10px;
  }

  .add-card {
    cursor: pointer;
  }

  .debit-card:hover,
  .debit-card:focus {
    background-color: lightgray;
    border: 0px solid lightgray;
    border-radius: 10px;
  }

  .debit-card .col-md-2 {
    padding-top: 5px;
  }
</style>